import { render, staticRenderFns } from "./DashboardGestaoRowDesempenho.vue?vue&type=template&id=061c9641&scoped=true"
import script from "./DashboardGestaoRowDesempenho.vue?vue&type=script&lang=js"
export * from "./DashboardGestaoRowDesempenho.vue?vue&type=script&lang=js"
import style0 from "./DashboardGestaoRowDesempenho.vue?vue&type=style&index=0&id=061c9641&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061c9641",
  null
  
)

export default component.exports